<h2 mat-dialog-title>{{isEdit ? 'SBOM-Projekt bearbeiten' : 'Neues SBOM-Projekt'}}</h2>

<mat-dialog-content>
  <div class="form-grid">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Projektname</mat-label>
      <input matInput [(ngModel)]="project.name" required placeholder="z.B. Abfüllanlage Linie 3">
      <mat-icon matPrefix>developer_board</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Kunde</mat-label>
      <mat-select [(ngModel)]="project.customerId" required>
        <mat-option *ngFor="let c of customers" [value]="c.id">{{c.name}}</mat-option>
      </mat-select>
      <mat-icon matPrefix>business</mat-icon>
    </mat-form-field>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Projektnummer</mat-label>
        <input matInput [(ngModel)]="project.projectNumber" placeholder="z.B. PRJ-2026-001">
        <mat-icon matPrefix>tag</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="project.status">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{statusLabels[s]}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="section-label">SPS / Steuerung</div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>SPS-Typ</mat-label>
        <input matInput [(ngModel)]="project.plcType" placeholder="z.B. S7-1500, TwinCAT 3">
        <mat-icon matPrefix>memory</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Firmware-Version</mat-label>
        <input matInput [(ngModel)]="project.plcFirmwareVersion" placeholder="z.B. V2.9.4">
      </mat-form-field>
    </div>

    <div class="section-label">Projekt-Hash</div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="hash-field">
        <mat-label>Hash-Wert</mat-label>
        <input matInput [(ngModel)]="project.projectHash" placeholder="z.B. a1b2c3d4e5f6...">
        <mat-icon matPrefix>fingerprint</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="algo-field">
        <mat-label>Algorithmus</mat-label>
        <mat-select [(ngModel)]="project.hashAlgorithm">
          <mat-option value="">-</mat-option>
          <mat-option *ngFor="let algo of hashAlgorithms" [value]="algo">{{algo}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Übergabedatum</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="project.handoverDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Beschreibung</mat-label>
      <textarea matInput [(ngModel)]="project.description" rows="2" placeholder="Projektbeschreibung..."></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Notizen</mat-label>
      <textarea matInput [(ngModel)]="project.notes" rows="2" placeholder="Interne Notizen..."></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!project.name?.trim() || !project.customerId || saving">
    <mat-spinner *ngIf="saving" diameter="18"></mat-spinner>
    {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>
